// Modules
import React from 'react';
import _ from 'lodash';

import { FormCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import Form from 'services/data/form';
import FormForm from 'components/models/company/form-form';
import SVG from 'components/widgets/icons/svg';
import appHistory from 'app-history';

import * as actions from '../store/actions';


export default function FormEdit({ routeParams: { formId }, id: companyId }) {
  const { data: company } = actions.useCompany(companyId);
  const { data: forms, refetch } = actions.useCompanyForms(companyId);
  const form = _.find(forms, { id: Number(formId) });

  const onSubmit = values => {
    const update = _.clone(values);

    return Form.update(update)
      .then(() => refetch())
      .then(() => {
        appHistory.push(`/companies/${company.id}/forms`);
      });
  };

  const initialValues = _.pick(form, ['company', 'title', 'id']);

  if (!form) return null;

  return (
    <PageContent className="bg-medium-blue-grey">
      <div className="form-summary flex flex-equal-children">
        <FormCard className="form-form">
          <div className="form-header">
            <SVG src="svg/checklist.svg" className="form-icon" />
            <h5 className="form-title">Edit Form</h5>
          </div>
          <FormForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );
}
